import React, { useEffect, useState } from 'react';
import {
    Typography,
    Divider,
    Button,
    Input,
    Row,
    Col,
    Radio,
    InputNumber,
} from 'antd';
import { useCouter } from '../../../hooks/useCouter';
import { formatMoney } from '../../../utils/general';
import { getCompanyIdApi } from '../../../api/company';
import food from '../../../assets/img/jpg/seafood.jpg';
import userOrder from '../../../hooks/useOrder';

import './DescriptionItem.scss';
import Secciones from './Secciones';

const DescriptionItem = (props) => {
    const { item, setIsModalVisible } = props;
    // const { item, setIsModalVisible, setCounterItem, setTotalOrder, totalOrder } = props;
    const { name, description, itemId, itemImage, price, itemSections } = item;
    const { Title, Paragraph } = Typography;
    const { TextArea } = Input;
    let { state, decrement, increment, setState } = useCouter(1);
    const [total, setTotal] = useState(0);
    const [instructions, setInstructions] = useState('');
    const [typeQuantity, setTypeQuantity] = useState(0);
    const [priceQuantity, setPriceQuantity] = useState(0);
    const [totalFinal, setTotalFinal] = useState(0);

    const [valueCheck, setValueCheck] = useState(2);

    const onChangeCheck = (e) => {
        setValueCheck(e.target.value);
    };

    const companyId = getCompanyIdApi();
    const { orderGeneral, setOrderGeneral } = userOrder();
    const [extraPrice, setExtraPrice] = useState(0.0);
    const [optionTable, setOptionTable] = useState([]);
    const { Subtotal } = orderGeneral;

    const filtradas = itemSections.filter((ele) => ele.available);
    let nameUnitOfMeasure;

    if (item.unitOfMeasure !== null) {
        switch (item.unitOfMeasure.unitType) {
            case 0:
                nameUnitOfMeasure = '';
                break;
            case 1:
                nameUnitOfMeasure = 'Kg';
                break;
            case 2:
                nameUnitOfMeasure = 'gr';
                break;
            case 3:
                nameUnitOfMeasure = 'Lt';
                break;
            case 4:
                nameUnitOfMeasure = 'ml';
                break;
            default:
                break;
        }
    }

    useEffect(() => {
        const found = orderGeneral.orderLinesList.find(
            (element) => element.itemId === itemId
        );
        if (found !== undefined && found !== null) {
            setInstructions(found.instructions);
            setState(found.quantity);
        } else {
            setInstructions('');
        }
        setTotal(0);
        return () => {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    useEffect(() => {
        if (typeQuantity !== 0) {
            setTotalFinal(total + (priceQuantity + extraPrice) * state);
        } else {
            setTotalFinal(total + (extraPrice + price) * state);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [extraPrice, price, state, priceQuantity, total]);

    const onChange = ({ target: { value } }) => {
        setInstructions(value);
    };
    const onChangeQuantity = (quantity) => {
        if (isNaN(quantity) === false) {
            const quantityNum = parseFloat(quantity).toFixed(3) || 0;
            setTypeQuantity(quantityNum);
            setPriceQuantity(quantityNum * price);
        }
    };
    const onChangePrice = (priceUoms) => {
        if (isNaN(priceUoms) === false) {
            setPriceQuantity(priceUoms);
            let cantidad = parseFloat(priceUoms / price).toFixed(3);
            setTypeQuantity(cantidad);
        }
    };

    const add = () => {
        const found = orderGeneral.orderLinesList.findIndex(
            (item) => item.itemId === itemId
        );

        if (found === -1) {
            //Es un platillo nuevo

            let result = {
                extraPrice,
                name: name,
                price: price,
                priceUoms: priceQuantity,
                measurementUnits: typeQuantity,
                typeUoms: nameUnitOfMeasure,
                altPrice: totalFinal,
                instructions: instructions,
                quantity: state,
                companyId: companyId,
                itemId: itemId,
                options: optionTable,
            };

            orderGeneral.orderLinesList.push(result);
            // setOrder(order);

            // setCounterItem(orderGeneral.orderLinesList.length);
            let total = Subtotal + totalFinal;
            // let total = totalOrder;

            // total = totalFinal ;

            // setTotalOrder(total);
            setOrderGeneral({
                ...orderGeneral,
                Subtotal: total,
            }); //nuevo hook
            setIsModalVisible(false);
        } else {
            //ya estaba
            if (item.itemSections.length > 0) {
                //se agregara como nuevo

                function uuidv4() {
                    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(
                        /[xy]/g,
                        function (c) {
                            // eslint-disable-next-line eqeqeq
                            // eslint-disable-next-line no-mixed-operators
                            var r = (Math.random() * 16) | 0,
                                v = c == 'x' ? r : (r & 0x3) | 0x8;
                            return v.toString(16);
                        }
                    );
                }
                let result = {
                    extraPrice,
                    name: name,
                    price: price,
                    priceUoms: priceQuantity,
                    measurementUnits: typeQuantity,
                    typeUoms: nameUnitOfMeasure,
                    altPrice: totalFinal,
                    instructions: instructions,
                    quantity: state,
                    companyId: companyId,
                    itemId: `${itemId}/${uuidv4()}`,
                    options: optionTable,
                };
                orderGeneral.orderLinesList.push(result);
                // setOrder(order);

                // setCounterItem(orderGeneral.orderLinesList.length);
                let total = Subtotal + totalFinal;
                // let total = totalOrder;

                // total = totalFinal;
                // setTotalOrder(total);
                setOrderGeneral({ ...orderGeneral, Subtotal: total }); //nuevo hook
                setIsModalVisible(false);
            } else {
                //Ya estaba en la cesta
                orderGeneral.orderLinesList[found].quantity = state;
                orderGeneral.orderLinesList[found].instructions = instructions;
                let suma = 0;

                orderGeneral.orderLinesList.forEach((element) => {
                    suma =
                        suma +
                        (element.extraPrice + element.price) * element.quantity;
                });
                setOrderGeneral({ ...orderGeneral, Subtotal: suma });
                setIsModalVisible(false);
            }
        }
    };
    const onSectionOptionsChanged = (table) => {
        let tmp = 0.0;
        let options = [];
        for (const [key, value] of Object.entries(table)) {
            let seccOriginal = itemSections.find((e) => e.itemSectionId == key);
            if (seccOriginal && seccOriginal.sectionOptions.length > 0) {
                if (value && value.length > 0) {
                    // eslint-disable-next-line no-loop-func
                    value.forEach((v) => {
                        const opt = {
                            ...seccOriginal.sectionOptions[v],
                            id: seccOriginal.itemSectionId,
                            nameSection: seccOriginal.name,
                        };
                        tmp = tmp + opt.price;
                        options.push(opt);
                    });
                }
            }
        }
        setOptionTable(options);
        setExtraPrice(parseFloat(tmp));
    };

    const obligatorySections = [];
    itemSections
        .filter((item) => item.obligatory && item.available)
        .forEach((item) =>
            item.sectionOptions.forEach((s) => {
                if (!obligatorySections.includes(s.itemSectionId))
                    obligatorySections.push(s.itemSectionId);
            })
        );
    const selectedObligatorySections = [];
    optionTable.forEach((opt) => {
        const original = itemSections.find(
            (sec) => sec.itemSectionId === opt.itemSectionId
        );

        if (
            original.obligatory &&
            !selectedObligatorySections.includes(opt.itemSectionId)
        )
            selectedObligatorySections.push(opt.itemSectionId);
    });
    const notAllSelected =
        obligatorySections.sort().toString() !=
        selectedObligatorySections.sort().toString();
    let invalidUom = false;
    let quantityMax;
    if (item.unitOfMeasure) {
        invalidUom =
            priceQuantity < item.unitOfMeasure.minimumPurchase ||
            priceQuantity > item.unitOfMeasure.maximumPurchase;
        quantityMax = item.unitOfMeasure.maximumPurchase / item.price;
    }
    return (
        <div className="description-item">
            <div className="description-item__container-image">
                <img
                    src={
                        itemImage !== null
                            ? `data:image/${itemImage.extension};base64, ${itemImage.imageData}`
                            : food
                    }
                    alt="Italian Trulli"
                ></img>
            </div>
            <div className="description-item__container">
                <Title level={3}>{name}</Title>
                <Title level={5}>
                    ${formatMoney(price)} {nameUnitOfMeasure}
                </Title>
                <p>{description}</p>
            </div>

            {item.unitOfMeasure !== null && (
                <div>
                    <Divider>Unidad de medida</Divider>
                    <Row className="justify-items-uoms">
                        <Col>
                            <p>Seleccionar unidad de medida:</p>
                        </Col>
                    </Row>
                    <Radio.Group onChange={onChangeCheck} value={valueCheck}>
                        <Radio value={2}>Cantidad</Radio>
                        <Radio value={1}>Precio</Radio>
                    </Radio.Group>

                    <Row className="justify-items-uoms">
                        <Col xs={24} lg={24}>
                            {valueCheck === 2 && (
                                <Row className="margin-left">
                                    <Col xs={19} lg={19}>
                                        <InputNumber
                                            precision={1}
                                            min={0}
                                            max={quantityMax}
                                            style={{
                                                width: '100%',
                                            }}
                                            formatter={(value) =>
                                                ` ${value}`.replace(
                                                    /\B(?=(\d{3})+(?!\d))/g,
                                                    ','
                                                )
                                            }
                                            parser={(value) =>
                                                value.replace(/\$\s?|(,*)/g, '')
                                            }
                                            placeholder="2"
                                            value={typeQuantity}
                                            onChange={(value) =>
                                                onChangeQuantity(value)
                                            }
                                        />
                                    </Col>
                                    <Col xs={5} lg={5}>
                                        <p className="margin-left">
                                            {' '}
                                            {nameUnitOfMeasure}
                                        </p>
                                    </Col>
                                </Row>
                            )}
                            {valueCheck === 1 && (
                                <Row className="margin-left">
                                    <Col xs={19} lg={19}>
                                        <InputNumber
                                            precision={2}
                                            min={0}
                                            max={
                                                item.unitOfMeasure
                                                    .maximumPurchase
                                            }
                                            style={{
                                                width: '100%',
                                            }}
                                            formatter={(value) =>
                                                `$ ${value}`.replace(
                                                    /\B(?=(\d{3})+(?!\d))/g,
                                                    ','
                                                )
                                            }
                                            parser={(value) =>
                                                value.replace(/\$\s?|(,*)/g, '')
                                            }
                                            placeholder="2"
                                            value={priceQuantity}
                                            onChange={(value) =>
                                                onChangePrice(value)
                                            }
                                        />
                                    </Col>
                                    <Col xs={5} lg={5}>
                                        {/* {typeQuantity && typeQuantity !== 0 && ( */}
                                        <p className="margin-left">
                                            {' '}
                                            {typeQuantity} {nameUnitOfMeasure}
                                        </p>
                                        {/* )} */}
                                    </Col>
                                </Row>
                            )}
                        </Col>
                    </Row>
                    <Col>
                        <p>
                            Máximo $
                            {formatMoney(item.unitOfMeasure.maximumPurchase)}
                        </p>
                        <p>
                            Mínimo $
                            {formatMoney(item.unitOfMeasure.minimumPurchase)}
                        </p>
                    </Col>
                    {/* {((priceQuantity && priceQuantity !== 0) || (typeQuantity !== 0)) && (
                        <>
                            <p>Total de {name}: ${formatMoney(priceQuantity)}</p>
                            <p>CANTIDAD: {typeQuantity} {nameUnitOfMeasure}</p>
                        </>
                    )
                    } */}
                </div>
            )}
            {itemSections.length >= 1 && filtradas.length >= 1 && (
                <>
                    <Divider>Ingredientes</Divider>
                </>
            )}

            <Secciones
                itemSections={itemSections}
                onChange={onSectionOptionsChanged}
            />
            <Divider>Instrucciones Especiales</Divider>
            <TextArea
                value={instructions}
                placeholder="Instrucciones Especiales"
                autoSize={{ minRows: 2, maxRows: 6 }}
                onChange={onChange}
            />
            <div className="description-item__container">
                <Divider>Cantidad</Divider>
                <Row className="counter">
                    <Col span={8}>
                        <Button
                            disabled={state === 1}
                            onClick={decrement}
                            danger
                        >
                            -
                        </Button>
                    </Col>
                    <Col span={8}>{state}</Col>
                    <Col span={8}>
                        <Button onClick={increment} danger>
                            +
                        </Button>
                    </Col>
                </Row>
                {item.unitOfMeasure !== null && typeQuantity !== 0 && (
                    <>
                        <Divider></Divider>
                        <Paragraph className="right">
                            {typeQuantity}
                            {nameUnitOfMeasure} {name}: $
                            {formatMoney(priceQuantity)}
                            <br />
                            Extras: ${formatMoney(extraPrice)}
                        </Paragraph>
                    </>
                )}
                <Divider></Divider>

                <Paragraph className="right">
                    Total: ${formatMoney(totalFinal)}
                </Paragraph>
            </div>
            <Button
                type="primary"
                danger
                block
                onClick={add}
                disabled={notAllSelected || invalidUom}
            >
                Agregar {state}
            </Button>
        </div>
    );
};

export default DescriptionItem;
